import { useProfile } from '@services/users/queries/useProfile'
import { LoadingPage } from '../../common'
import { ReactNode } from 'react'

type AccessControlProps = {
  children: ReactNode
  role: string | string[]
  exactRole?: boolean
  requirePartner?: boolean
}

export function AccessControl({ children, role, exactRole = false, requirePartner = false }: AccessControlProps) {
  const { data, isLoading, isError } = useProfile(true)

  const getRole = () => {
    if (exactRole) {
      return data?.role
    }
    if (
      data?.role === 'USER' ||
      data?.role === 'ROOMMATE'
    ) {
      return 'USER'
    }
    return data?.role
  }

  if (isLoading || isError) return <LoadingPage />

  // Check for partner privilege via is_partner flag
  if (requirePartner && !data?.is_partner) return null

  const userRole = getRole()
  if (!userRole) return null
  const hasAccess = Array.isArray(role) ? role.includes(userRole) : userRole === role
  return hasAccess ? <>{children}</> : null
}
